module.exports = __webpack_public_path__ + "img/kaifashang_bg2.3b2d4b15.png";